import { TechStackItem } from "./styles"

interface TechItemProps{
    TechItem:{
        name: string,
        icon: string
    }
}
export function TechItem(props: TechItemProps){
    return(
        <TechStackItem>
            <i className={props.TechItem.icon}></i>
            <p>{props.TechItem.name}</p>
        </TechStackItem>
    )
}